import { ResponsivePie } from "@nivo/pie"
import { FunctionComponent } from "react"
import Color from "../Color"
import { Record, RecordType } from "../Type"
import { getRecordType } from "../Utils"

type ChartData = {
  id: string
  value: number
  label: string
  color: string
}

const PieChart: FunctionComponent<{
  records: Record[]
  recordTypes: RecordType[]
}> = ({ records, recordTypes }) => {
  const prepareChartData = (
    records: Record[],
    recordTypes: RecordType[]
  ): Array<ChartData> => {
    const creditData: Map<string, ChartData> = new Map<string, ChartData>()
    const debitData: Map<string, ChartData> = new Map<string, ChartData>()
    let recTypeName: string
    let data: ChartData
    for (let record of records) {
      recTypeName = getRecordType(record, recordTypes).name
      if (record.credit) {
        // Credit recType map
        if (creditData.has(recTypeName)) {
          // new recType
          data = creditData.get(recTypeName) as ChartData
          data.value += record.amount / 100
          creditData.set(recTypeName, data)
        } else {
          // existing recType
          creditData.set(recTypeName, {
            id: `${recTypeName} (credit)`,
            value: record.amount / 100,
            label: `${recTypeName} (credit)`,
            color: Color.Primary,
          })
        }
      } else {
        // Debit recType map
        if (debitData.has(recTypeName)) {
          // new recType
          data = debitData.get(recTypeName) as ChartData
          data.value += record.amount / 100
          debitData.set(recTypeName, data)
        } else {
          // existing recType
          debitData.set(recTypeName, {
            id: `${recTypeName} (debit)`,
            value: record.amount / 100,
            label: `${recTypeName} (debit)`,
            color: Color.Gray75,
          })
        }
      }
    }
    const chartData = new Array()
    chartData.push(Array.from(creditData.values()))
    chartData.push(Array.from(debitData.values()))
    // console.log(chartData.flat())
    return chartData.flat()
  }

  return (
    <ResponsivePie
      data={prepareChartData(records, recordTypes)}
      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      innerRadius={0.5}
      padAngle={0.7}
      colors={{ datum: "data.color" }}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
    />
  )
}

export default PieChart
